import TiptapEditorContextProvider from "@src/features/libraryItem/course/contexts/TiptapEditorContext";
import { cn } from "@src/lib/utils/cn";
import { FC } from "react";
import RichTextEditor from "../course/RichTextEditor";

type RichTextProps = {
  text: string;
  /** Opus Docs treat the first block as a large title; disable for plain read-only snippets. */
  disableDocumentTitleStyle?: boolean;
};

const ReadOnlyTrainingRichTextDocument: FC<RichTextProps> = ({
  text,
  disableDocumentTitleStyle = false,
}) => {
  return (
    <TiptapEditorContextProvider tiptapEditorId={`rich-text-read-only-${text}`}>
      <RichTextEditor
        key={`rich-text-read-only-${text}`}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={cn(
          "rich-text-opus-doc-editor",
          disableDocumentTitleStyle &&
            "rich-text-opus-doc-editor--no-doc-title",
        )}
        text={text || ""}
        disableTextVariants
        onChange={() => {}}
        hasEditContentPermission={false}
        enableMathematics={true}
      />
    </TiptapEditorContextProvider>
  );
};

export default ReadOnlyTrainingRichTextDocument;
